import grain1 from "../assets/grain1.webp";
import grain2 from "../assets/grain2.webp";
import grain3 from "../assets/grain3.webp";
import grain4 from "../assets/grain4.webp";
import grain5 from "../assets/grain5.webp";
import grain6 from "../assets/grain6.webp";
import grain7 from "../assets/grain7.png";
import grain8 from "../assets/grain8.jpg";
import grain9 from "../assets/grain9.jpg";
import grain10 from "../assets/grain10.jpg";
import grain11 from "../assets/grain11.jpeg";

const whiskymade = [
  {
    image: grain1,
    name: "single malt whisky",
    info: "This is a whisky from a single distillery made using only malted barley, water and yeast. Single Malt Scotch Whiskies come from four regions across Scotland: Lowlands, Highlands, Speyside and Islay. The different areas are known for their unique characteristics like fruitiness, freshness, maltiness and smokiness.",
  },
  {
    image: grain2,
    name: "grain whisky",
    info: "The main ingredient of these whiskies is maize, wheat, or both, rather than barley. They can come from a single distillery or be blended from different distilleries across Scotland. Grain whiskies have a lighter, creamy flavor, which make them ideal in whisky blends, where they bring together the flavors of single malts.",
  },
  {
    image: grain3,
    name: "blend whisky",
    info: "A Blended Scotch Whisky is made by mixing together Single Malt Whiskies and Single Grain Whiskies. This creates a broader depth of flavor and allows the flavor and quality of the whisky to stay the same time after time. When a Blended Whisky states its age, this refers to the youngest whisky used in the blend.",
  },
  {
    image: grain4,
    name: "THE JOHNNIE WALKER PAPER-BASED BOTTLE",
    info: "Coming soon: the first recyclable, paper-based spirits bottle from Johnnie Walker.",
  },
  {
    image: grain5,
    name: "STEP INTO THE FUTURE OF SOCIALISING",
    info: "A new and revolutionary social experience with sustainability at its core.",
  },
  {
    image: grain6,
    name: "NOT ONE DROP WILL BE WASTED",
    info: "A water sustainability commitment to cut the amount of water used to make Johnnie Walker whisky by 20%.",
  },
  {
    image: grain7,
    price: "$35 per person",
    green: "single malts tasting",
    name: "whisky explorers at the explorers' bothy",
    info: "Join us in our top floor Explorers' Bothy Bar bar for a top tier whisky tasting. Led by our specialist, you’ll enjoy a curated exploration of five extraordinary Scottish whiskies, each matured for a minimum of 12 years..",
  },
  {
    image: grain8,
    green: "our premium experience",
    price: "$48 per person",
    name: "stir at the explorers' bothy",
    info: "Come experience STIR, an exclusive new collaboration launched with two Michelin-starred team James & Maria Close to combine world-class cocktails with innovative cuisine..",
  },
  {
    image: grain9,
    price: "$65 per person",
    green: "special events",
    name: "johnnie & the chocolatier: johnnie walker luxury whisky & artisanal chocolate pairing",
    info: "Join us for a special tutored tasting of four iconic Johnnie Walker whiskies, each accompanied by a luxury chocolate truffle. Guided by our whisky experts..",
  },
  {
    image: grain10,
    price: "$90 per person",
    green: "our premium experience",
    name: "whisky makers' cellar",
    info: "Step into our unique underground cellar and enjoy exceptional whiskies taken straight from the cask, including our exclusive Johnnie Walker Princes Street expression made right here..",
  },
  {
    image: grain11,
    price: "$50 per person",
    green: "special event",
    name: "johnnie walkers history adventure",
    info: "Discover the legends behind the label as our expert Archivist takes you through the inspiring story of John Walker and sons, served with a cocktail and an immersive performance.",
  },
];

export default whiskymade;
